import { RehydrationWatcher } from 'components/_shared/widgets/rehydration';
import { SharedRehydrationProps } from 'components/_shared/widgets/rehydration/types';
import { useState, useCallback } from 'react';

export interface RehydrationRenderControlProps {
  children: JSX.Element;
  loading?: JSX.Element;
  fallback?: JSX.Element;
}

const RehydrationRenderControl = ({
  children,
  loading,
  fallback,
  ...restProps
}: SharedRehydrationProps & RehydrationRenderControlProps) => {
  const [hasCompleted, setHasCompleted] = useState(false);
  const [hasTimedOut, setHasTimedOut] = useState(false);

  const completed = useCallback(() => setHasCompleted(true), []);
  const timedOut = useCallback(() => setHasTimedOut(true), []);

  if (hasCompleted) return children;
  if (fallback && hasTimedOut) return fallback;

  return (
    <>
      {!!loading && <>{loading}</>}

      <RehydrationWatcher
        {...restProps}
        onRehydrate={completed}
        onTimeOut={fallback ? timedOut : completed}
      />
    </>
  );
};

export default RehydrationRenderControl;
